import type { Element } from "React";
type Props = {
  className?: string;
  color?: string;
};

const IconChevronDown = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    className={props.className}
    style={{ color: props.color || "var(--base-color)" }} // Use passed color or fallback to CSS variable
  >
    <title id="title">Arrow</title>
    <path
      d="M4.722 8.5L12.5 16.278 20.278 8.5"
      fill={props.color || "currentColor"}
    />{" "}
  </svg>
);

export default IconChevronDown;
